<template>
	<div class="card bg-base-100 shadow">
		<div class="card-body">
			<div class="flex flex-wrap items-center justify-between gap-3">
				<div class="flex items-center gap-3">
					<div class="card-title flex items-center gap-2 text-xl">
						{{ t('customGraph.list.title') }}
					</div>
					<span class="badge badge-neutral badge-sm" aria-label="graph-count">
						{{ graphCount }}
					</span>
				</div>
				<div class="flex w-full items-center gap-2 sm:w-auto sm:justify-end">
					<input
						type="search"
						class="input input-bordered input-sm w-full max-w-xs"
						:placeholder="t('customGraph.list.filterPlaceholder')"
						v-model.trim="filterQuery" />
					<!-- Developers only: server-side recalc-all run over every graph -->
					<RecalcAllButton v-if="authStore.isDev" kind="graphs" :count="recalcIds.length" :ids="recalcIds" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import { useGraphs } from './_useGraphs'
	import RecalcAllButton from '@/features/admin/RecalcAllButton.vue'
	import { useAuthStore } from '@/stores/auth.store'

	const { t, filterQuery, graphCount, graphEntries } = useGraphs()
	const authStore = useAuthStore()

	// The run follows the list as sorted right now; a graph listed on several
	// levels goes once.
	const recalcIds = computed(() => [
		...new Set(graphEntries.value.map((e) => e.graph?._id).filter((id): id is string => !!id)),
	])
</script>
